import { useDispatch, useSelector } from "react-redux";
import { profileSelectors } from "../selectors";
import { profileActions } from "../actions";

export interface CurrencySelection {
  currency: string;
  handleCurrencyChange: (currency: string) => void;
}

export const useCurrencySelection = (): CurrencySelection => {
  const { currentCurrency } = useSelector(profileSelectors.getGlobal);
  const dispatch = useDispatch();

  const handleCurrencyChange = (selectedCurrency: string) => {
    dispatch(
      profileActions.setGlobalState({
        currentCurrency: selectedCurrency,
      })
    );
  };

  return {
    currency: currentCurrency,
    handleCurrencyChange,
  };
};
